/**
 * Collapse
 *
 * Toggles "show more/lesse" on content elements
 */

(function Collapse() {
    const elements = $('.has-collapse');
    const classes = {
        active: 'is-active'
    };

    /**
     * Create
     */
    function create() {
        $.each(elements, function(index, element) {
            initializeCollapse($(element));
        });
    }

    function initializeCollapse(collapseElement) {
        collapseElement.find('.collapse__trigger').on('click', function() {
            toggleCollapse($(this));
        });
    }

    function toggleCollapse(collapseTrigger) {
        collapseTrigger.closest('.has-collapse').toggleClass(classes.active);
    }

    if (elements.length > 0) {
        create();
    }
})();